import { CircleCheck } from '@/src/assets/icons/CircleCheck'
import { mesaColorNames } from '@/src/common/theme'
import { Paragraph, XStack } from 'tamagui'

export function MortgageVerified() {
  return (
    <XStack flex={1} gap="$1" items="center" justify="center">
      <CircleCheck color={mesaColorNames['semantic/fg/success #008557']} />
      <Paragraph color={mesaColorNames['semantic/fg/success #008557']}>
        Your mortgage statement has been verified.
      </Paragraph>
    </XStack>
  )
}
